export default "__VITE_ASSET__6c1ee946__"